import React from 'react'
import Select from 'react-select';
import { disabledGrey, defaultGrey } from '../../prop-types';

export interface IOption {
  value: string,
  label: string,
}

interface ISelectProps {
  type?: "number" | "text";
  options: IOption[]
  initialOption: IOption
  onChange: (option: IOption) => void,
}

const selectStyles = {
  control: (styles: any) => ({ ...styles, backgroundColor: 'white', border: 'none'}),
  valueContainer: (styles: any) => ({ ...styles,
    padding: '0px',
    justifyContent: 'center'
  }),
  option: (styles: any, { data = {}, isDisabled= false, isFocused = false, isSelected = false }) => {
    return {
      ...styles,
      textAlign: 'center',
      backgroundColor: isFocused ? disabledGrey : ( isSelected ? defaultGrey : 'white'),
      color: 'inherit',
      cursor: isDisabled ? 'not-allowed' : 'default',
      border: 'none',
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
    };
  }
};


export default function SelectInput(props: ISelectProps) {
  const { options, initialOption, onChange, type= "text" } = props;
  // TODO: optional rendering based on type?
  return (
    <Select
      value={initialOption}
      onChange={onChange}
      options={options}
      styles={selectStyles}
    />
  )
}
